<template>
  <footer
    class="embedded-footer"
    :class="isCoverTypePage ? 'cover-type-page-style' : ''"
  >
    <div class="embeddedNewTab">
      <p>
        Paymentshield Limited (registered number 02728936) is a company
        registered in England and Wales at Southport Business Park, Wight Moss
        Way, Southport, PR8 4HQ. VAT registration no: GB 447284724. Telephone
        calls may be recorded for security purposes and monitored under our
        quality control procedures. Paymentshield Limited is authorised and
        regulated by the Financial Conduct Authority (FCA) under registration
        No. 312708.See the Financial Services Register for further details.
      </p>
      <div class="d-flex align-center">
        <a
          href="https://www.paymentshield.co.uk/fair-processing-notice"
          target="_blank"
        >
          Privacy policy
        </a>
        <a
          class="ml-8"
          href="https://www.paymentshield.co.uk/website-terms-conditions"
          target="_blank"
        >
          Terms & conditions
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { ROUTE_NAME } from "@/constants/route.constants";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapGetters } from "vuex";

export default {
  name: "EmbedFooter",

  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["isSelfServe"]),
    isCoverTypePage() {
      return (
        this.$route.name === ROUTE_NAME.LANDLORDS.D2C.COVER_TYPE ||
        (this.isSelfServe && this.$route.path === "/")
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.cover-type-page-style {
  margin-top: 0px !important;
}

.embedded-footer {
  width: 100%;
  padding-bottom: 40px;

  .embeddedNewTab {
    padding: 0px 24px;
    color: $black-2 !important;
    max-width: 1128px;
    margin: 0 auto;
    p {
      font-size: 11px !important;
    }
    a {
      font-size: 14px !important;
    }
  }

  .footer-link {
    font-family: "MontserratMedium";
    font-size: 14px;
    line-height: 17px;
    color: map-get($amber, "base");
    text-align: right;
    margin-left: 10px;
    cursor: pointer;
  }
}

@media screen and (min-width: ($grid-breakpoints-xs)) {
  .footer-link {
    margin-left: 32px !important;
  }
  .embeddedNewTab {
    padding: 40px 0px;
  }
}

@media screen and (min-width: $grid-breakpoints-lg) {
  .cover-type-page-style {
    margin-top: -82px !important;
  }
}
</style>
